import ProjectForm from '../project-form';
import {EditDialogButton} from '@/components/refinedev/dialogs/edit-dialog-button';
import {BaseKey, UseCanProps} from '@refinedev/core';

export const ProjectEditDialogButton = ({
  resource = 'projects',
  id,
  onSuccess,
  canParams,
  // forceCan,
}: {
  resource?: string;
  id: BaseKey;
  onSuccess?: (data) => void;
  // forceCan?: boolean;
  canParams?: UseCanProps['params'];
}) => {
  return (
    <EditDialogButton
      id={id}
      resource={resource}
      title="Chỉnh sửa dự án"
      canParams={canParams}
      // forceCan={forceCan}
      transformBeforeSave={ProjectForm.transformBeforeSave}
      formProps={{
        refineCoreProps: {
          onMutationSuccess: onSuccess,
          meta: {with: ['members']},
        },
      }}>
      <div className="flex flex-col gap-4">
        <ProjectForm />
      </div>
    </EditDialogButton>
  );
};
